"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Text_1 = require("../Text/Text");
var Link_1 = __importDefault(require("../Link/Link"));
var styled_components_1 = __importDefault(require("styled-components"));
var Breadcrumb = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, external = _a.external, _c = _a.label, label = _c === void 0 ? 'breadcrumb' : _c, _d = _a.link, link = _d === void 0 ? '' : _d, _e = _a.testid, testid = _e === void 0 ? 'breadcrumb' : _e;
    return (React.createElement(StyledBreadcrumb, { className: className, "data-testid": testid }, Boolean(link) ? (React.createElement(StyledLink, { "aria-label": "Go to the ".concat(label, " page"), route: !external, to: link },
        React.createElement(Text_1.Caption, { "$darkGrey": true }, label))) : (React.createElement(Text_1.Caption, { "$darkGrey": true }, label))));
};
exports.default = Breadcrumb;
var StyledBreadcrumb = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex: 0 0 auto;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 18px;\n"], ["\n    flex: 0 0 auto;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 18px;\n"])));
var StyledLink = (0, styled_components_1.default)(Link_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-decoration: none;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: 18px;\n    &:hover {\n        text-decoration: underline;\n        span {\n            color: ", ";\n        }\n    }\n"], ["\n    text-decoration: none;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: 18px;\n    &:hover {\n        text-decoration: underline;\n        span {\n            color: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue200;
});
var templateObject_1, templateObject_2;
